import { Link } from 'react-router-dom';
import { useIdentity } from '../../identity/state/useIdentity';
import { MODULE_READINESS, PRODUCTION_PROCESSING_STATUS } from '../../dashboard/moduleReadiness';

export function SettingsPage() {
  const { me, logout, showCompanyPicker } = useIdentity();
  const active = me?.memberships.find((m) => m.companyId === me.activeCompanyId);

  return (
    <>
      <section className="card card--wide">
        <h2>Settings</h2>
        <p><strong>Signed in as</strong> {me?.email}</p>
        <p><strong>Active company</strong> {active?.companyName} ({active?.roleName})</p>
        <p>
          <Link to="/settings/subscription">Subscription plan &amp; billing →</Link>
        </p>
        <p>
          <Link to="/settings/billing">Billing: invoices, payment method &amp; support →</Link>
        </p>
        <p className="muted">
          No further staging application settings exist yet in this build — this page is intentionally
          minimal rather than showing configuration options no backend supports.
        </p>
        <div className="inline-form">
          {me && me.memberships.length > 1 && (
            <button type="button" onClick={showCompanyPicker}>Switch company</button>
          )}
          <button type="button" onClick={() => void logout()}>Sign out</button>
        </div>
      </section>

      <section className="card card--wide">
        <h2>System Status</h2>
        <p className="muted">Mirrors <code>docs/module-readiness.md</code> — see that document for full evidence per module. Previously shown on the Dashboard, moved here when the Dashboard route became the real Escochex financial dashboard.</p>
        <ul className="readiness-list">
          {MODULE_READINESS.map((m) => (
            <li key={m.navPath ?? m.name} className={`readiness-${m.level}`}>
              {m.number !== null ? `Module ${m.number}: ` : ''}{m.name} — {m.status}
            </li>
          ))}
          <li className="readiness-blocked">{PRODUCTION_PROCESSING_STATUS}</li>
        </ul>
      </section>
    </>
  );
}
